<div class="h-auto mt-4 mx-2">
  <!--  <span mat-dialog-title class="mt-0"><strong>Notification Feeds</strong></span>-->
  <h1 mat-dialog-title>Notification Feeds</h1>

  <mat-dialog-content [style]="{padding :'0px'}">
    <mat-list>
      <div *ngIf="(notificationsData.data?.length||0) <= 0" class="text-center">
        {{ notificationsData.networkState == 'Loading' ? 'Loading...' : 'There is no data.' }}
      </div>
      <div *ngFor="let notification of notificationsData.data"
           class="matListItem my-2 py-2">
        <mat-list-item class="h-100">
          <div class="d-flex content">
            <div class="me-3">
              <i-feather name="bell" class="icon"></i-feather>
            </div>
            <div class="text-container">
              <p class="mb-1 fw-normal">{{ notification.content }}</p>
              <div class="text-end text-secondary fs-7">
                <small>{{ getDate(notification.createdDate) }}</small>
              </div>
            </div>
          </div>
        </mat-list-item>
      </div>
    </mat-list>

  </mat-dialog-content>

</div>

